import { TroubleTicketingSelectOptions } from './selectOptions';

export type SingleTroubleTicketingCategory = {
	tab: string; // tab name
	id: 'OTHERS' | 'BILLINGS' | 'TECHNICAL';
	select: TroubleTicketingSelectOptions; // select options
};

const model = {
	tab: 'tab',
	select: 'select',
	id: 'id',
};

export default model;
